/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const commonFlexColumn = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
} as const;

export const useJiraSupportStyles = makeStyles((theme: Theme) => ({
  root: {
    ...commonFlexColumn,
    gap: theme.spacing(2),
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  title: {
    color: theme.palette.scalefieldTextPrimary.main,
    fontSize: '32px',
    lineHeight: '38px',
    fontWeight: 'bold',
  },
  newIssueButton: {
    width: '10%',
  },
  select: {
    width: '30%',
  },
  gapFour: {
    ...commonFlexColumn,
    gap: theme.spacing(4),
  },
  gapThree: {
    ...commonFlexColumn,
    gap: theme.spacing(3),
  },
  subHeader: {
    color: theme.palette.scalefieldTextSecondary.main,
  },
  header: {
    color: theme.palette.scalefieldTextPrimary.main,
    fontWeight: 'bold',
  },
  commentName: {
    color: 'black',
    fontWeight: 'bold',
  },
  commentAvatar: {
    borderRadius: '50%',
    height: '30px',
    width: '30px',
  },
  gapOne: {
    ...commonFlexColumn,
    gap: theme.spacing(1),
  },
  card: {
    ...commonFlexColumn,
    padding: theme.spacing(2),
    backgroundColor: theme.palette.scalefieldCardBackground.main,
    boxShadow: 'none',
    color: 'black',
  },
  halfGap: {
    ...commonFlexColumn,
    gap: theme.spacing(0.5),
  },
  inputLabel: {
    transform: 'none',
    position: 'relative',
    marginBottom: theme.spacing(1),
  },
  uploadFile: {
    padding: '5px',
    minWidth: '135px',
    maxWidth: '135px',
    '& *': {
      cursor: 'pointer',
    },
  },
  fileChooser: {
    width: '0.1px',
    height: '0.1px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1,
  },
}));
